import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { v4 as uuid } from "uuid";
import { savingsPlanDrawerRecommendationsGridColumns } from "./SavingsPlanDrawerRecommendationsGridColumns";
import { useGetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsQuery } from "../../../../../../../../services/cloudchipr.api";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { utilizationAndCoverageDrawerTargetIdSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/details-drawer/options/utilizationAndCoverageDrawerTargetIdSelector";
import { DataGrid } from "../../../../../../../../storybook/data-grid/DataGrid";
import { StylesProps } from "../../../../../../../../storybook/data-grid/utils/types/prop-types";

export const SavingsPlanDrawerRecommendationsSection: FC = () => {
  const savingsPlanId = useAppSelector(
    utilizationAndCoverageDrawerTargetIdSelector,
  );

  const { data } =
    useGetUsersMeOrganisationsCurrentSavingsPlansUtilizationRecommendationsQuery(
      { savingsPlanId: savingsPlanId ?? "" },
      {
        skip: !savingsPlanId,
        selectFromResult: ({ data }) => {
          return {
            data: data?.map((recommendation) => ({
              ...recommendation,
              id: uuid(),
            })),
          };
        },
      },
    );

  return (
    <Stack p={2} spacing={2}>
      <Typography variant="h5" fontWeight="bold">
        Recommendations
      </Typography>

      {!data?.length ? (
        <Stack alignItems="center" p={3}>
          <Typography
            variant="subtitle1"
            fontWeight="medium"
            color="text.secondary"
          >
            No Recommendations
          </Typography>
        </Stack>
      ) : (
        <DataGrid
          enableStickyColumns
          columnSorting
          styles={styles}
          data={data}
          columns={savingsPlanDrawerRecommendationsGridColumns}
        />
      )}
    </Stack>
  );
};

const styles: StylesProps["styles"] = {
  table: {
    borderCollapse: "separate",
    tableLayout: "fixed",
    "& th": { py: 2, bgcolor: "white" },
    "& th:first-of-type": { pl: 2 },
    "& td:first-of-type": { pl: 2 },
    "& tr:hover td": { bgcolor: grey[100] },
    "& tr td": { borderColor: grey[100], bgcolor: "white" },
  },

  tableContainer: {
    bgcolor: "white",
    borderRadius: 2,
    border: "1px solid",
    borderColor: "grey.300",
  },
};
